import request from '../api/request'

// 查询所有角色
export function queryRoleList(param) {
    return request({
      url: '/role/listAll',
      method: 'get',
      params: param
    })
}

//分页查询角色
export function queryRoleListByPage(param) {
    return request({
      url: '/role/list',
      method: 'get',
      params: param
    })
}

//新建角色
export function addRole(data) {
    return request({
      url: '/role/add',
      method: 'post',
      data: data
    })
}

//修改角色
export function modifyRole(data) {
    return request({
      url: '/role',
      method: 'put',
      data: data
    })
}

//修改角色
export function updateRoleState(data) {
    return request({
      url: '/role/updateRoleState',
      method: 'put',
      data: data
    })
}
